export const CANDIDATE_RECONNECT_TOPIC = 'candidate_reconnect_interval'
const MAX_RECONNECT_INTERVAL_MS = 2 * 60 * 60_000

export interface CandidateReconnectInterval {
  id: string
  startedAt: number
  roomSid?: string
}

export interface CandidateReconnectPacket {
  type: typeof CANDIDATE_RECONNECT_TOPIC
  id: string
  roomSid: string
  startedAt: number
  finishedAt: number
  sentAt: number
}

/** Repeated media reconnect events can describe the same network interruption. */
export function beginCandidateReconnect(
  current: CandidateReconnectInterval | null, startedAt: number, roomSid: string | undefined, id: string,
): CandidateReconnectInterval {
  return current ?? {id, startedAt, roomSid}
}

/** A new LiveKit SID is a separate interview and must not receive the old interval. */
export function finishCandidateReconnect(
  interval: CandidateReconnectInterval | null, roomSid: string, finishedAt: number, sentAt: number,
): CandidateReconnectPacket | null {
  if (!interval?.roomSid || interval.roomSid !== roomSid || !interval.id
    || ![interval.startedAt, finishedAt, sentAt].every(Number.isFinite)
    || interval.startedAt <= 0 || finishedAt <= interval.startedAt || sentAt < finishedAt
    || finishedAt - interval.startedAt > MAX_RECONNECT_INTERVAL_MS
    || sentAt - finishedAt > MAX_RECONNECT_INTERVAL_MS) return null
  return {type: CANDIDATE_RECONNECT_TOPIC, id: interval.id, roomSid,
    startedAt: interval.startedAt, finishedAt, sentAt}
}
